import ApproverSearch from '../../2compounds/ApproverSearch'
import {useEffect, useState} from 'react'
import GroupCreateModalBase from '../../2compounds/GroupCreateModalBase'

const SelectOwnerModal = ({open, setOpen, owner, setOwner}) => {
    const [ownerTemp, setOwnerTemp] = useState(null)

    const cancelHandler = () => {
        setOpen(false)
    }

    const saveHandler = () => {
        setOwner(ownerTemp)
        setOpen(false)
    }

    useEffect(()=>{
        setOwnerTemp(owner)
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])

    return (
        <GroupCreateModalBase header='Select an owner'
                              saveHandler={saveHandler}
                              cancelHandler={cancelHandler}
                              open={open}
                              setOpen={setOpen}>
            <ApproverSearch approver={ownerTemp}
                            setApprover={setOwnerTemp} />
        </GroupCreateModalBase>
    )
}

export default SelectOwnerModal
